module.exports = __webpack_public_path__ + "media/images/riders/BRENDAN_FAIRCLOUGH-6568b2e60e6d6c4fb8280b7edcf64742.png";